import { ActiveUnit, Booking, BookingDetails, Customer, Location } from 'types';
import GateUnit from 'types/gate-unit';
import { BaseDataType } from 'types/iti-base-entity';

export const isNotNull = <T extends BaseDataType>(value?: T | null): value is T => !!value;

export const isBaseDataType = (value?: unknown): value is BaseDataType =>
  !!value && typeof value === 'object' && 'id' in value;

export const isBooking = (value?: unknown): value is Booking => isBaseDataType(value) && 'bookingDetails' in value;

export const isBookingDetails = (value?: unknown): value is BookingDetails => isBaseDataType(value) && 'iso' in value;

export const isCustomer = (value?: unknown): value is Customer =>
  isBaseDataType(value) && 'name' in value && 'code' in value && 'ediRecipients' in value;

export const isLocation = (value?: unknown): value is Location =>
  isBaseDataType(value) && 'name' in value && 'code' in value && 'timeZone' in value;

export const isUnit = (value?: unknown): value is ActiveUnit => isBaseDataType(value) && 'unitNumber' in value;

export const isGateUnit = (value?: unknown): value is GateUnit =>
  isBaseDataType(value) && 'unitNumber' in value && 'booking' in value && 'redelivery' in value;
